import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { useLocation } from "@hooks/use-location"
import { SeoType } from "@types/seo-type"
import { DirectusSeo } from "./seo/directusSeo"
import { LegacySeo } from "./seo/legacySeo"

export function Seo({
  canonical,
  description,
  lang,
  meta,
  title,
  titleExtension,
  image = null,
  seo,
  body,
  date_updated,
}) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            siteUrl
          }
        }
      }
    `
  )

  const location = useLocation()
  const metaDescription = description || site.siteMetadata.description
  const defaultTitle = titleExtension ?? site.siteMetadata?.title

  return seo ? (
    <DirectusSeo
      canonical={canonical}
      seo={seo}
      lang={lang}
      meta={meta}
      image={image}
      body={body}
      date_updated={date_updated}
      defaultTitle={defaultTitle}
      location={location}
      site={site}
    />
  ) : (
    <LegacySeo
      canonical={canonical}
      lang={lang}
      meta={meta}
      image={image}
      title={title}
      description={metaDescription}
      defaultTitle={defaultTitle}
      location={location}
      site={site}
    />
  )
}

Seo.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
  titleExtension: PropTypes.string,
  canonical: PropTypes.string,
  image: PropTypes.string,
  body: PropTypes.string,
  seo: SeoType,
  date_updated: PropTypes.string,
}

export default Seo
